export default [
  {
    path: '/appeal',
    component: () => import('../../views/appeal/appeal.vue'),
    name: 'appeal',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
      title: '申诉',
    },
  },
  {
    auth: 0,
    path: '/appeal-result',
    component: () => import('../../views/appeal/appealResult.vue'),
    name: 'appeal-result',
    meta: {
      backgroundClass: 'bg-gray',
      title: '申诉',
    },
  },
];
